import { render } from "./ClaimCdk.vue?vue&type=template&id=4dc48e53&scoped=true"
import script from "./ClaimCdk.vue?vue&type=script&lang=js"
export * from "./ClaimCdk.vue?vue&type=script&lang=js"

import "./ClaimCdk.vue?vue&type=style&index=0&id=4dc48e53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc48e53"]])

export default __exports__